import { render, staticRenderFns } from "./EmptyChannels.vue?vue&type=template&id=a445acae&scoped=true&"
import script from "./EmptyChannels.vue?vue&type=script&lang=js&"
export * from "./EmptyChannels.vue?vue&type=script&lang=js&"
import style0 from "./EmptyChannels.vue?vue&type=style&index=0&id=a445acae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a445acae",
  null
  
)

export default component.exports